import React from 'react';
import {useAuth} from '../../modules/auth/AuthContext';


function Profile() {
  const {user} = useAuth();
  return (
    <>
    <div className="profileContainer">
      <div className="profile">
        <h2>プロフィール</h2>
        <p>ユーザー名：{user.name}</p>
        <p>メールアドレス：{user.email}</p>
        </div>
    </div>
    </>
  )
}

export default Profile;